import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { fetchMovie, clearMovie } from "../movie/movieActions";
import { fetchCast } from "./castActions";
import CastCard from "./CastCard";
import Spinner from "../../components/Spinner";

const CastPage = (props) => {
  const dispatch = useDispatch();
  const { data: movie, loading } = useSelector((s) => s.movie);
  const imdbID = props.match.params.id;
  const [cast, setCast] = useState([]);
  const [castLoading, setCastLoading] = useState(true);

  useEffect(() => {
    dispatch(fetchMovie(imdbID));
    return () => dispatch(clearMovie());
  }, [dispatch, imdbID]);

  useEffect(() => {
    if (!movie) return;
    setCastLoading(true);
    fetchCast(movie).then((result) => {
      setCast(result);
      setCastLoading(false);
    });
  }, [movie]);

  if (loading || !movie) return <Spinner />;

  return (
    <div className="cast-container mt-4 mb-5">
      <div className="d-flex align-items-center mb-4">
        <button
          className="btn btn-outline-light mr-3"
          onClick={() => props.history.goBack()}
        >
          <i className="fas fa-arrow-left"></i>
        </button>
        <div>
          <h2 className="mb-0">Cast of {movie.Title}</h2>
          <small className="text-muted">
            {movie.Year} &bull; {cast.length} members
          </small>
        </div>
      </div>

      {castLoading ? (
        <Spinner />
      ) : cast.length > 0 ? (
        <div className="cast-grid">
          {cast.map((member) => (
            <CastCard key={member.id} member={member} movie={movie} />
          ))}
        </div>
      ) : (
        <p className="text-muted text-center mt-5">
          No cast information available.
        </p>
      )}

      <div className="text-center mt-4">
        <Link to={`/movie/${imdbID}`} className="btn btn-primary mr-2">
          <i className="fas fa-info-circle mr-1"></i> Movie Details
        </Link>
      </div>
    </div>
  );
};

export default CastPage;
